// English translations for all tool components
export default {
  UrlCodec: {
    title: 'URL Encode / Decode',
    componentMode: 'Component', componentTip: 'encodeURI — keeps URL structure characters like / ? = & #, only encodes non-ASCII',
    fullMode: 'Full', fullTip: 'encodeURIComponent — all non-alphanumeric characters become %XX',
    phInput: 'Enter text or an encoded string…', phPasted: 'Paste the content to encode or decode…',
    hintEmpty: 'Enter text, then click Encode or Decode', detectEncoded: 'Encoded content detected, try Decode',
    detectPlain: 'Plain text detected, try Encode', msgEncoded: 'Encoded · {n} chars',
    msgEncodeFail: 'Encode failed: {msg}', msgDecoded: 'Decoded · {n} chars',
    msgDecodeFail: 'Decode failed — invalid URL-encoded input',
    sample: 'https://example.com/search?q=hello world&lang=en'
  },
  UnicodeCodec: {
    title: 'Unicode Encode / Decode', phInput: 'Enter text or Unicode escape sequences…',
    phPasted: 'Paste the content to encode or decode…', hintEmpty: 'Enter text, then click Encode or Decode',
    detectEncoded: 'Unicode escapes detected, try Decode', detectPlain: 'Plain text detected, try Encode',
    msgEncoded: 'Encoded · {n} chars', msgEncodeFail: 'Encode failed: {msg}',
    msgDecoded: 'Decoded · {n} chars', msgDecodeFail: 'Decode failed — invalid Unicode escape format',
    sample: 'Hello World 🌍 \\u4f60\\u597d \\u4e16\\u754c! 😀 \\uD83D\\uDE00'
  },
  Base64Codec: {
    title: 'Base64 Encode / Decode', urlSafe: 'URL-safe',
    urlSafeTip: 'Replace + with -, / with _, drop trailing =', phInput: 'Enter text or a Base64 string…',
    phPasted: 'Paste the content to encode or decode…', hintEmpty: 'Enter text, then click Encode or Decode',
    detectBase64: 'Base64 detected, try Decode', detectPlain: 'Plain text detected, try Encode',
    msgEncoded: 'Encoded · {n} chars', msgEncodeFail: 'Encode failed: {msg}',
    msgDecoded: 'Decoded · {n} chars', msgDecodeFail: 'Decode failed — invalid Base64',
    sample: 'Hello World 🌍'
  },
  JsonEditor: {
    title: 'JSON Formatter', phInput: 'Paste JSON...',
    hintEmpty: 'Paste JSON and click Format', valid: 'Valid JSON',
    validatePass: 'JSON is valid', noContent: 'Nothing to copy', copyFailed: 'Copy failed'
  },
  SqlFormatter: {
    title: 'SQL Formatter', phInput: 'Paste SQL...',
    hintEmpty: 'Paste a SQL statement and click Format'
  },
  CodeEditor: {
    title: 'Code Formatter',
    phJs: 'Paste JavaScript code...', phHtml: 'Paste HTML code...',
    phCss: 'Paste CSS code...', phSql: 'Paste SQL...', phJava: 'Paste Java code...',
    phC: 'Paste C code...', phCpp: 'Paste C++ code...', phPython: 'Paste Python code...', phGo: 'Paste Go code...'
  },
  Generator: {
    title: 'Random String Generator', desc: 'Set parameters to generate random strings',
    lenLabel: 'Length', lenHint: '4-512 chars', countLabel: 'Count ({n})',
    charsetLabel: 'Charset', charsetAlphanum: 'Letters + Digits', charsetAll: 'Letters + Digits + Symbols',
    charsetUpper: 'Uppercase only', charsetLower: 'Lowercase only', charsetDigits: 'Digits only',
    charsetHex: 'Hex (0-9 A-F)', btnGenerate: 'Generate',
    resultLabel: 'Results ({n})', copyAll: 'Copy All', copy: 'Copy', empty: 'Click Generate',
    copiedAll: 'All copied'
  },
  DiffViewer: {
    subtitle: 'Text Diff · line-by-line with character highlighting', paneA: 'Original', phA: 'Enter original text...',
    paneB: 'New', phB: 'Enter new text...', same: '{n} same', removed: '{n} removed',
    added: '{n} added', modified: '{n} modified', copyDiff: 'Copy diff',
    empty: 'Type to compare', copiedDiff: 'Diff copied'
  },
  Calculator: {
    title: 'Simple Calculator', copyResult: 'Copy Result', hint: '+ − × ÷ % √ ^ |x| () · Enter to calculate',
    invalidResult: 'Invalid result', exprError: 'Expression error', noResult: 'No result'
  },
  Converter: {
    selectType: 'Select conversion', typeBase64Encode: 'Base64 Encode', typeBase64Decode: 'Base64 Decode',
    typeUrlEncode: 'URL Encode', typeUrlDecode: 'URL Decode', typeUnicodeDecode: 'Unicode → Text',
    typeUnicodeEncode: 'Text → Unicode', typeCaseToggle: 'Toggle Case',
    input: 'Input', phInput: 'Enter content...', output: 'Output', convertFail: 'Conversion failed: {msg}'
  },
  ColorPicker: { pickColor: 'Pick a color', copy: 'Copy' },
  QrcodeGenerator: { phInput: 'Enter text or URL...', download: 'Download' },
  WordToHtml: {
    upload: 'Upload Word', uploadHint: '.docx / .doc · Max 50MB',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    btnConvert: 'Convert', result: 'Result', resultHint: 'HTML Preview',
    download: 'Download HTML', reupload: 'Re-upload', maxSize: 'Max 50MB', convertFail: 'Conversion failed'
  },
  HtmlToWord: {
    title: 'HTML to Word', preview: 'Preview', download: 'Download Word',
    phHtml: 'Paste HTML code…', previewTitle: 'Preview',
    hintChars: '{n} chars', hintPreviewMode: ' · Preview', hintEmpty: 'Paste HTML and click Download Word',
    downloading: 'Downloading...', emptyDoc: 'Empty document',
    sampleDocTitle: 'Document Title', sampleBold: 'bold', sampleItalic: 'italic',
    sampleName: 'Name', sampleAge: 'Age', sampleNameVal: 'John', sampleAgeVal: '28'
  },
  ImageBgRemove: {
    title: 'ID Photo Background', upload: 'Upload Photo', uploadHint: 'PNG / JPEG · max 20MB',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    btnRed: 'Red', btnWhite: 'White', btnBlue: 'Blue',
    customColor: 'Custom', precision: 'Precision', download: 'Download PNG',
    reupload: 'Re-upload', maxSize: 'Max 20MB', noFile: 'Please upload an image',
    processing: 'Processing...', done: 'Done'
  },
  ImageCompress: {
    title: 'Image Compressor', upload: 'Upload Image', uploadHint: 'PNG / JPEG / WebP · max 20MB',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    quality: 'Quality', original: 'Original', compressed: 'Compressed',
    btnCompress: 'Compress', download: 'Download', reupload: 'Re-upload',
    maxSize: 'Max 20MB', noFile: 'Please upload an image'
  },
  ImageOcr: {
    title: 'Image OCR', upload: 'Upload Image', uploadHint: 'PNG / JPEG / WebP',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    btnStart: 'Start OCR', resultLabel: 'Result', copy: 'Copy',
    reupload: 'Re-upload', processing: 'Recognizing...', noFile: 'Please upload an image',
    noText: 'No text detected', maxSize: 'File size cannot exceed 50MB'
  },
  QrDecoder: {
    title: 'QR Code Decoder', upload: 'Upload QR Code', uploadHint: 'PNG / JPEG',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    btnDecode: 'Decode', resultLabel: 'Decoded Content', reupload: 'Re-upload',
    processing: 'Decoding...', noFile: 'Please upload an image', noResult: 'No QR code detected'
  },
  ColorExtractor: {
    title: 'Color Extractor', upload: 'Upload Image', uploadHint: 'PNG / JPEG · click to extract color',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    resultLabel: 'Picked Color', reupload: 'Re-upload', noFile: 'Please upload an image'
  },
  IconGenerator: {
    title: 'Icon Generator', shape: 'Shape', shapeRounded: 'Rounded', shapeCircle: 'Circle', shapeSquare: 'Square', shapeDiamond: 'Diamond',
    bgColor: 'Background', text: 'Text', fontSize: 'Font Size', radius: 'Radius',
    download16: '16px', download32: '32px', download64: '64px', download128: '128px', download256: '256px'
  },
  CryptoTool: {
    title: 'Crypto Tool', modeAES: 'AES', modeHash: 'Hash', modeHMAC: 'HMAC', modeRSA: 'RSA', modeEncode: 'Encoding',
    aesMode: 'Mode', aesCBC: 'CBC', aesGCM: 'GCM', aesKey: 'Key', aesKey128: '128-bit', aesKey256: '256-bit',
    aesIv: 'IV', aesInput: 'Input', aesOutput: 'Output', aesEncrypt: 'Encrypt', aesDecrypt: 'Decrypt',
    hashAlgo: 'Algorithm', hashInput: 'Input', hashOutput: 'Output',
    rsaGenerate: 'Generate Key Pair', rsaPubKey: 'Public Key', rsaPrivKey: 'Private Key', rsaEncrypt: 'Encrypt', rsaDecrypt: 'Decrypt',
    encType: 'Type', encInput: 'Input', encOutput: 'Output',
    plaintext: 'Plaintext', ciphertext: 'Ciphertext', ciphertextBase64: 'Ciphertext (Base64)',
    raw: 'Raw', text: 'Text', encoded: 'Encoded',
    genKey: 'Generate Key', randomKey: 'Random Key', computeHash: 'Compute Hash', upper: 'Uppercase', computeHmac: 'Compute HMAC',
    phKey: 'Secret key', phPlaintext: 'Enter plaintext...', phCiphertext: 'Encrypted output...',
    phMsg: 'Enter message...', phInput: 'Enter...', phResult: 'Result...',
    phHexBits: '{n} hex chars', genRsaKey: 'Generate 2048-bit Key Pair', ready: 'Ready',
    errEncrypt: 'Encryption failed', errDecrypt: 'Decryption failed', errGen: 'Generation failed', errNeedKey: 'Please generate a key pair first'
  },
  TimestampTool: {
    title: 'Timestamp Converter', current: 'Current Timestamp', tsToDate: 'Timestamp → Date', dateToTs: 'Date → Timestamp',
    tsPlaceholder: 'Enter timestamp (seconds or ms)', datePlaceholder: 'Select date & time',
    result: 'Result', copy: 'Copy', now: 'Now',
    unixSeconds: 'Unix Seconds', unixMillis: 'Unix Millis', localTime: 'Local Time',
    input: 'Input', output: 'Output',
    tsInputHint: 'Enter 10-digit or 13-digit number', dateInputHint: 'Enter a date-time string',
    nowBtn: 'Now', tryTs: 'Try pasting a timestamp:', tryDate: 'Try pasting a date:',
    commonRefs: 'Common References', todayRef: 'Today 00:00',
    currentTimeRef: 'Current Time', year2038Ref: 'Year 2038 Boundary',
    weekDays: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], weekPrefix: ' ',
    phTs: 'e.g. 1717084800', phDate: 'e.g. 2026-05-30 12:00',
    errDigits: 'Please enter a numeric timestamp', errLength: 'Please enter a 10-digit (seconds) or 13-digit (milliseconds) timestamp',
    errInvalidTs: 'Invalid timestamp', errUnrecognized: 'Unrecognized date format, try 2026-05-30 or 2026-05-30 12:00:00',
    resultLocalTime: 'Local Time', resultUtcTime: 'UTC Time', resultIso8601: 'ISO 8601',
    resultUnixSec: 'Unix Seconds (10-digit)', resultUnixMs: 'Unix Millis (13-digit)', resultDateLocal: 'Corresponding Local Time'
  },
  JwtDecoder: {
    title: 'JWT Decoder', modeDecode: 'Decode', modeEncode: 'Encode',
    headerLabel: 'Header', payloadLabel: 'Payload', signatureLabel: 'Signature',
    jwtInput: 'Paste JWT Token (xxxxx.yyyyy.zzzzz)…', secretLabel: 'Secret (optional, for verification)',
    algoLabel: 'Algorithm', algoHS256: 'HS256', algoHS384: 'HS384', algoHS512: 'HS512', algoNone: 'none',
    statusExpired: 'Expired', statusValid: 'Valid', verifyOk: '✓ Valid', verifyFail: '✗ Invalid',
    claimsIss: 'Issuer', claimsSub: 'Subject', claimsAud: 'Audience', claimsIat: 'Issued At', claimsExp: 'Expires',
    claimsNbf: 'Not Before', claimsJti: 'JWT ID',
    sigHint: ' (The signature prevents tampering. Header/Payload are only Base64-encoded, not encrypted, so no key is needed for decoding)',
    phVerifySecret: 'Enter secret to verify (HS256)', phEncSecret: 'Signing secret (optional, leave blank to skip)',
    verify: 'Verify', generate: 'Generate JWT', generatedJwt: 'Generated JWT',
    decodeOk: 'Decoded successfully', decodeHint: 'Paste a JWT token to decode',
    errFormat: 'Invalid JWT format, expected header.payload.signature', errParse: 'Parse failed', errEncode: 'Encode failed',
    jsonHint: ' (JSON)'
  },
  YamlJson: {
    title: 'YAML / JSON', inputLabel: 'YAML', outputLabel: 'JSON',
    phInput: 'Enter YAML or JSON, click a button to convert...', phOutput: 'Paste JSON...',
    yamlToJson: 'YAML → JSON', jsonToYaml: 'JSON → YAML',
    hint: 'Paste YAML or JSON and click a button to convert',
    errYaml: 'YAML parse error', errJson: 'JSON format error'
  },
  BaseConverter: {
    title: 'Base Converter', dec: 'DEC', hex: 'HEX', bin: 'BIN', oct: 'OCT',
    hint: 'Enter a value in any field, the rest auto-convert',
    phDec: 'e.g. 255', phHex: 'e.g. FF', phBin: 'e.g. 11111111', phOct: 'e.g. 377',
    errInvalid: 'Invalid {radix} value', errConvert: 'Conversion failed'
  },
  UuidGenerator: {
    title: 'UUID Generator', version: 'Version', count: 'Count', upper: 'Uppercase',
    btnGenerate: 'Generate', copyAll: 'Copy All', copy: 'Copy', copiedAll: 'All copied',
    emptyHint: 'Click Generate to create UUIDs'
  },
  CaseConverter: {
    title: 'Case Converter', input: 'Input', output: 'Output',
    copySelected: 'Copy Selected', copied: 'Copied',
    phInput: 'Enter text to convert to 8 naming styles in real time...',
    hintEmpty: 'Enter text to auto-convert to 8 naming styles · Click a card to copy',
    types: { upper: 'UPPERCASE', lower: 'lowercase', title: 'Title Case', camel: 'camelCase',
      pascal: 'PascalCase', snake: 'snake_case', kebab: 'kebab-case', constant: 'CONSTANT' }
  },
  TextDedup: {
    title: 'Text Dedup & Sort', input: 'Input', output: 'Output', btnDedup: 'Dedup', btnSort: 'Sort',
    btnSortAsc: 'Sort Asc', btnSortDesc: 'Sort Desc', btnReverse: 'Reverse', btnTrim: 'Trim Empty',
    phInput: 'One item per line. Paste text and click a button above...', phOutput: 'Result...',
    hintEmpty: 'One item per line. Supports dedup, sort, reverse, and blank line removal',
    hintLines: '{lines} lines · {chars} chars',
    msgDedup: 'Dedup: {before} → {after} lines ({removed} removed)',
    msgSortAsc: 'Sorted ascending · {n} lines', msgSortDesc: 'Sorted descending · {n} lines',
    msgReverse: 'Reversed · {n} lines', msgTrim: 'Trimmed: {before} → {after} lines ({removed} removed)'
  },
  PasswordStrength: {
    title: 'Password Strength', generate: 'Generate Strong Password', strength: 'Strength',
    levels: { 0: 'None', 1: 'Weak', 2: 'Fair', 3: 'Strong', 4: 'Very Strong' },
    criteria: { length: '≥ 8 chars', length12: '≥ 12 chars', upper: 'Uppercase', lower: 'Lowercase', digit: 'Digit', symbol: 'Symbol' },
    phPassword: 'Enter password…', showPassword: 'Show', hidePassword: 'Hide',
    hintEmpty: 'Enter a password to check its strength'
  },
  XmlFormatter: { title: 'XML Formatter', phInput: 'Paste XML...', btnFormat: 'Format', btnToJson: '→ JSON' },
  HttpStatus: {
    title: 'HTTP Status Codes', search: 'Search status codes...', category: 'Category', code: 'Code', description: 'Description',
    categories: { info: 'Informational', success: 'Success', redirect: 'Redirection', clientError: 'Client Error', serverError: 'Server Error' }
  },
  HtmlEntity: {
    title: 'HTML Entity Encode/Decode', input: 'Input', output: 'Output',
    btnEncode: 'Encode', btnDecode: 'Decode', phInput: 'Enter text or HTML code...', phOutput: 'Entity result...',
    hint: 'Enter text, then click Encode/Decode/Format/Compress',
    encoded: 'Encoding done', decoded: 'Decoding done',
    formatted: 'Formatting done', compressed: 'Compression done',
    chars: 'chars'
  },
  UnitConverter: {
    title: 'Unit Converter', typeLabel: 'Type', valueLabel: 'Value',
    fromLabel: 'From', toLabel: 'To', resultLabel: 'Result',
    phValue: 'Enter value', swapTitle: 'Swap units',
    hint: 'Choose a type, enter a value to convert',
    types: { storage: 'Storage', length: 'Length', weight: 'Weight', temp: 'Temperature', time: 'Time' },
    units: {
      storage: { B:'B (Byte)', KB:'KB', MB:'MB', GB:'GB', TB:'TB' },
      length: { mm:'Millimeter (mm)', cm:'Centimeter (cm)', m:'Meter (m)', km:'Kilometer (km)', in:'Inch (in)', ft:'Foot (ft)', mi:'Mile (mi)' },
      weight: { mg:'Milligram (mg)', g:'Gram (g)', kg:'Kilogram (kg)', t:'Ton (t)', oz:'Ounce (oz)', lb:'Pound (lb)' },
      temp: { c:'Celsius (°C)', f:'Fahrenheit (°F)', k:'Kelvin (K)' },
      time: { ms:'Millisecond (ms)', s:'Second (s)', min:'Minute (min)', h:'Hour (h)', d:'Day (d)', w:'Week (w)' }
    }
  },
  YamlProperties: {
    title: 'YAML / Properties', inputLabel: 'YAML', outputLabel: 'Properties',
    phInput: 'Enter YAML or Properties, click a button to convert...', phOutput: 'Paste Properties...',
    yamlToProp: 'YAML → Properties', propToYaml: 'Properties → YAML',
    hint: 'Paste YAML or Properties and click a button to convert',
    errYaml: 'YAML parse error', errProp: 'Properties format error'
  },
  ApiTester: {
    title: 'HTTP API Tester', method: 'Method', url: 'URL', headers: 'Headers',
    body: 'Body', send: 'Send', response: 'Response', status: 'Status', time: 'Time',
    phUrl: 'https://api.example.com/endpoint', phKey: 'Key', phValue: 'Value',
    history: 'History', noResponse: 'Click Send to make a request',
    addHeader: 'Add', copyBody: 'Copy Body', copyAll: 'Copy All', errRequest: 'Request failed'
  },
  SqlQuery: {
    title: 'Online SQL Query', host: 'Host', port: 'Port', user: 'User', password: 'Password', database: 'Database',
    btnConnect: 'Connect', btnDisconnect: 'Disconnect', reconnect: 'Reconnect', tables: 'Tables',
    editor: 'SQL Editor', btnRun: 'Run (Ctrl+Enter)', result: 'Result', connected: 'Connected',
    tableCount: ' tables', copyResult: 'Copy Result', readonlyHint: 'Only SELECT / SHOW / DESCRIBE / EXPLAIN allowed',
    hintLimit: 'Without LIMIT, 10 rows returned by default', timeout: 'Query timeout',
    errConnect: 'Connection failed', errQuery: 'Query failed',
    directMode: 'Direct', agentMode: 'Agent',
    sessionId: 'Session ID', phSessionId: 'Enter session ID from Agent',
    downloadAgent: 'Download Agent', agentHelp: "Can't reach LAN database? Download Agent to bridge",
    errAgentConnect: 'Cannot connect to Agent. Verify session ID and ensure Agent is running',
    agentDisconnected: 'Agent disconnected', reconnecting: 'Connection lost, reconnecting...', reconnectFailed: 'Reconnect failed, check if Agent is running'
  },
  RedisQuery: {
    title: 'Online Redis Query', host: 'Host', port: 'Port', password: 'Password (optional)', db: 'DB',
    btnConnect: 'Connect', btnDisconnect: 'Disconnect', connected: 'Connected', command: 'Command', btnRun: 'Execute',
    result: 'Result', hintReadonly: 'Read-only commands only', hintCommands: 'Supports: GET / MGET / HGET / HGETALL...',
    timeout: 'Query timeout', errConnect: 'Connection failed', errQuery: 'Query failed',
    directMode: 'Direct', agentMode: 'Agent', reconnect: 'Reconnect',
    sessionId: 'Session ID', phSessionId: 'Enter session ID from Agent',
    downloadAgent: 'Download Agent', agentHelp: "Can't reach LAN Redis? Download Agent to bridge",
    errAgentConnect: 'Cannot connect to Agent. Verify session ID and ensure Agent is running',
    agentDisconnected: 'Agent disconnected', reconnecting: 'Connection lost, reconnecting...', reconnectFailed: 'Reconnect failed, check if Agent is running',
    items: 'items', fields: 'fields', filterField: 'Filter field...', noMatch: 'No matching fields',
    keyNotExist: '(key does not exist)', expandAll: 'Expand all', collapse: 'Collapse', showMore: 'Show more'
  },
  MarkdownEditor: {
    title: 'Markdown Editor', input: 'Editor', preview: 'Preview',
    phInput: 'Write Markdown here...', loadSample: 'Load Sample',
    previewTitle: 'Live Preview', previewHint: 'Enter Markdown above to preview here',
    stats: '{chars} chars {lines} lines', copied: 'Preview content copied',
    toolbar: { bold:'Bold Ctrl+B',italic:'Italic',strikethrough:'Strikethrough',inlineCode:'Inline Code',ul:'Bullet List',ol:'Ordered List',task:'Task List',quote:'Blockquote',link:'Link',image:'Image',table:'Table',code:'Code Block',hr:'Divider' },
    tips: { bold:'Bold text',italic:'Italic text',code:'Inline code',link:'Hyperlink',task:'Task list',quote:'Blockquote',table:'Table syntax' },
    quickRef: 'Quick Reference'
  },
  DnsLookup: {
    title: 'DNS Lookup', domain: 'Domain', type: 'Record Type', btnQuery: 'Query',
    result: 'Result', phDomain: 'Enter domain, e.g. example.com', noResult: 'Enter a domain',
    recordCount: ' records', colIndex: '#', colType: 'Type', colValue: 'Value', colTtl: 'TTL',
    emptyHint: 'Enter a domain and click Query', errNoRecords: 'No DNS records found for this type', errNetworkError: 'Network error'
  },
  WebsocketTester: {
    title: 'WebSocket Tester', url: 'Server URL', btnConnect: 'Connect', btnDisconnect: 'Disconnect',
    message: 'Message', btnSend: 'Send', log: 'Message Log', status: 'Status',
    statusConnected: 'Connected', statusDisconnected: 'Disconnected', statusConnecting: 'Connecting...',
    phUrl: 'wss://echo.websocket.org', phMessage: 'Type a message, Enter to send',
    messageCount: ' messages', emptyHint: 'Connect to a WebSocket service to send and receive messages',
    errConnect: 'Connection failed', logConnected: 'Connected', logAbnormal: 'Connection error', logClosed: 'Connection closed'
  },
  SslChecker: {
    title: 'SSL Certificate Checker', domain: 'Domain', btnQuery: 'Query',
    result: 'Certificate Info', issuer: 'Issuer', validFrom: 'Valid From', validTo: 'Valid To',
    daysLeft: 'Days Left', algo: 'Algorithm', sanLabel: 'SAN', phDomain: 'Enter domain',
    expired: 'Expired', expiringSoon: 'Expiring Soon', valid: 'Valid',
    remaining: 'Remaining', days: ' days', to: ' to ',
    sigAlg: 'Signature Algorithm', publicKey: 'Public Key',
    certInfo: 'Certificate Info', domainLabel: 'Domain', issuerLabel: 'Issuer',
    certType: 'Cert Type', validity: 'Validity', tlsProtocol: 'TLS Protocol',
    sanCount: ' domains', certChain: 'Certificate Chain', chainLevel: ' level',
    siteCert: 'Site Cert', rootCert: 'Root Cert', intermediateCert: 'Intermediate Cert', issuerBy: 'Issued By',
    expiryDate: 'Expiry', emptyHint: 'Enter a domain and click Query',
    errDomainRequired: 'Please enter a domain', errNetworkError: 'Network error'
  },
  CoordConverter: {
    title: 'Coordinate Converter', mode: 'Mode', single: 'Single', batch: 'Batch',
    from: 'From', to: 'To', lng: 'Longitude', lat: 'Latitude',
    btnConvert: 'Convert', result: 'Result', phBatch: 'lng,lat (one per line)'
  },
  RegexTester: {
    title: 'Regex Tester', regexLabel: 'Pattern', testLabel: 'Test Text',
    phRegex: 'Enter regex...', phTest: 'Enter test text...', result: 'Matches',
    references: 'Common Patterns', matchCount: '{n} matches', noMatch: 'No match',
    patternHint: 'Enter a regex pattern, e.g. \\d{4}-\\d{2}-\\d{2}',
    flagFull: 'Full', fullMatch: 'Full Match', matchOk: '✓ Full match', matchFail: '✗ No match',
    totalMatches: '{n} matches total', itemCount: ' items',
    phTestArea: 'Paste or type the text to test here…',
    emptyTitle: 'Regex Tester', emptyDesc: 'Enter a regex pattern + test text to see matches in real time',
    emptyStep1: 'Enter a regex pattern above', emptyStep2: 'Paste test text below', emptyStep3: 'View highlighted matches and results',
    quickRef: 'Quick try:',
    refEmail: 'Email', refPhone: 'Phone', refUrl: 'URL', refDate: 'Date',
    refIp: 'IP Address', refChinese: 'Chinese', refHexColor: 'Hex Color', refIdCard: 'ID Card'
  },
  CronGenerator: {
    title: 'Cron Expression Generator', fields: { minute: 'Minute', hour: 'Hour', day: 'Day', month: 'Month', weekday: 'Weekday' },
    every: 'Every', specific: 'Specific', range: 'Range', step: 'Step',
    preview: 'Preview', expression: 'Expression', humanReadable: 'Description', nextRuns: 'Next 5 runs',
    presets: 'Presets', presetEveryMinute: 'Every Minute', presetEveryHour: 'Every Hour', presetEveryDay: 'Daily Midnight', presetEveryWeek: 'Weekly Monday',
    builderTitle: 'Visual Builder', builderHint: 'No syntax to remember, just select to generate',
    expressionAndDesc: 'Expression & Description', copyExpression: 'Copy Expression',
    next5Runs: 'Next 5 Run Times', timezone: 'Timezone',
    errNoMatch: 'Expression matches no times, please check your configuration', errFixSyntax: 'Please fix expression syntax errors first',
    sec: 'Sec', min: 'Min', hour: 'Hour', day: 'Day', month: 'Month', week: 'Week',
    weekdayNames: { 0:'Sun',1:'Mon',2:'Tue',3:'Wed',4:'Thu',5:'Fri',6:'Sat' },
    weekHint: '0=Sun 1=Mon … 6=Sat', weekRangeHint: ' (0=Sun 6=Sat)',
    from: 'From', to: 'To', stepUnit: ' step', start: 'From', startStep: ', every',
    presetsSec: { everySec:'Every Sec', every15:'Every 15s', every30:'Every 30s', specific:'Specific' },
    presetsMin: { everyMin:'Every Min', every5:'Every 5min', every10:'Every 10min', every15:'Every 15min', every30:'Every 30min', specific:'Specific' },
    presetsHour: { everyHour:'Every Hour', every2:'Every 2h', every6:'Every 6h', every12:'Every 12h', specific:'Specific' },
    presetsDay: { everyDay:'Every Day', lastDay:'Last Day', specific:'Specific', range:'Range' },
    presetsMonth: { everyMonth:'Every Month', specific:'Specific', range:'Range' },
    presetsWeek: { any:'Any', workday:'Weekdays', weekend:'Weekends', specific:'Specific', range:'Range' },
    tzBeijing: 'Beijing UTC+8', tzTokyo: 'Tokyo UTC+9', tzSingapore: 'Singapore UTC+8',
    tzLondon: 'London UTC+0', tzParis: 'Paris UTC+1', tzMoscow: 'Moscow UTC+3',
    tzNewYork: 'New York UTC-5', tzLosAngeles: 'Los Angeles UTC-8', tzSydney: 'Sydney UTC+11',
    tzDubai: 'Dubai UTC+4', tzMumbai: 'Mumbai UTC+5:30',
    tzSeoul: 'Seoul UTC+9', tzBerlin: 'Berlin UTC+1/+2', tzChicago: 'Chicago UTC-6/-5',
    tzSaoPaulo: 'Sao Paulo UTC-3', tzAuckland: 'Auckland UTC+12/+13', tzUTC: 'UTC +0',
    descEverySec: 'Every second', descEveryMin: 'Every minute', descEveryHourMin: 'At minute {min} of every hour',
    descOClock: '', descMonth: '', descWeek: '', descWorkday: 'every weekday', descWeekend: 'every weekend',
    descMorning: '', descAfternoon: '', descEvening: '', descMidnight: '', descExecute: '',
    errNeedFields: 'At least 5 fields required (min hour day month weekday)', errTooManyFields: 'Too many fields (max 7: sec min hour day month weekday year)',
    errFieldFormat: 'Field {n} ({name}) format error, range {min}-{max}',
    copied: 'Copied to clipboard', copyFailed: 'Copy failed'
  },
  PhoneList: {
    title: 'Common Numbers', search: 'Search...', copy: 'Click to copy',
    totalRecords: '{n} records · Click to copy', notFound: 'No matching numbers found',
    copied: 'Copied {phone}',
    groups: {
      emergency:{ name:'Emergency',items:{police:'Police',fire:'Fire',ambulance:'Ambulance',traffic:'Traffic Police',smsPolice:'SMS Police',forestFire:'Forest Fire',seaRescue:'Maritime Rescue',redCross:'Red Cross'} },
      life:{ name:'Utilities',items:{dirAssist:'Directory',weather:'Weather',time:'Speaking Clock',electric:'Power',water:'Water',gas:'Gas',tv:'Cable TV',community:'Community'} },
      telecom:{ name:'Telecom',items:{cmcc:'China Mobile',cucc:'China Unicom',ct:'China Telecom',cbn:'China Broadnet',phoneFault:'Line Fault',netReport:'Internet Report'} },
      bank:{ name:'Banking',items:{icbc:'ICBC',abc:'ABC',boc:'Bank of China',ccb:'CCB',bocom:'BankComm',cmb:'CMB',psbc:'PSBC',citic:'CITIC',spdb:'SPD Bank',unionpay:'UnionPay',alipay:'Alipay',wechatPay:'WeChat Pay'} },
      express:{ name:'Courier',items:{ems:'EMS',sf:'SF Express',zto:'ZTO Express',yto:'YTO Express',sto:'STO Express',yd:'Yunda Express',jd:'JD Logistics',deppon:'Deppon',jtexpress:'J&T Express',cainiao:'Cainiao'} },
      traffic:{ name:'Transport',items:{railway:'Railway',airline:'Aviation',highwayRescue:'Highway Rescue',roadRescue:'Road Rescue',didi:'DiDi'} },
      gov:{ name:'Government',items:{govService:'Gov Service',consumer:'Consumer Complaints',quality:'Quality Supervision',tax:'Tax Service',env:'Environment',discipline:'Discipline',legalAid:'Legal Aid',socialSecurity:'Social Security',housingFund:'Housing Fund',health:'Health',culture:'Culture'} },
      insurance:{ name:'Insurance',items:{picc:'PICC',chinalife:'China Life',pingan:'Ping An',cpic:'CPIC',taiping:'Taiping'} },
      ecommerce:{ name:'E-Commerce',items:{taobao:'Taobao/Tmall',jdcom:'JD.com',pinduoduo:'Pinduoduo',douyin:'Douyin',meituan:'Meituan',eleme:'Ele.me',ctrip:'Trip.com'} },
      airline:{ name:'Airlines',items:{airchina:'Air China',eastern:'China Eastern',southern:'China Southern',hainan:'Hainan Airlines',xiamen:'Xiamen Air',sichuan:'Sichuan Airlines',shenzhen:'Shenzhen Airlines',spring:'Spring Airlines'} }
    }
  },
  LocationQuery: {
    title: 'Location Lookup', phone: 'Phone', ip: 'IP', idcard: 'ID Card',
    ipTitle: 'IP Location Lookup', idcardTitle: 'ID Card Lookup', phoneTitle: 'Phone Location Lookup',
    phPhone: 'Enter first 3 or 7 digits', phIp: 'Enter IP address...', phIdcard: 'Enter 18-digit ID number',
    btnQuery: 'Query', result: 'Result',
    country: 'Country', province: 'Province', city: 'City', isp: 'ISP', carrier: 'Carrier',
    ipHint: 'Enter an IP and press Enter or click Query',
    district: 'Province / City / District', birth: 'Date of Birth', gender: 'Gender', age: 'Age',
    male: '👨 Male', female: '👩 Female',
    needMoreDigits: '{n} more digits needed', invalidIdcard: 'Please enter a valid ID number',
    phoneHint: 'Enter 3 digits for carrier, 7 for location',
    queryFailed: 'Query failed', checkNetwork: 'Please check your network',
    unknown: 'Unknown', notRecorded: 'Not recorded'
  },
  CharCount: {
    title: 'Word Count', hint: 'Live stats', chars: 'Chars', words: 'Words', lines: 'Lines', bytes: 'Bytes',
    sentences: 'Sentences', paragraphs: 'Paragraphs', chineseChars: 'CJK Chars',
    totalChars: 'Total Characters', charsNoSpace: 'Chars (no spaces)', bytesUTF8: 'Bytes (UTF-8)',
    phInput: 'Type or paste text...', wordCount: 'Word Count', lineCount: 'Line Count',
    cnCharCount: 'CJK Characters', sentenceCount: 'Sentence Count', paragraphCount: 'Paragraph Count'
  },
  MortgageCalculator: {
    title: 'Mortgage Calculator', commercial: 'Commercial Loan', fund: 'Provident Fund',
    amount: 'Loan Amount (10k)', years: 'Term', rate: 'Rate (%)',
    method: 'Method', methodEI: 'Equal P&I', methodEP: 'Equal Principal',
    monthly: 'Monthly Payment', total: 'Total Payment', interest: 'Total Interest',
    yearLabel: '{y}yr ({n} periods)', commercialLoan: 'Commercial', fundLoan: 'Provident Fund',
    perMonth: '/mo', principalNote: '* Equal principal payments decrease each month; range shown is first month to last month',
    detailTitle: 'Payment Schedule ({n} periods)',
    colPeriod: '#', colPayment: 'Payment', colPrincipal: 'Principal', colInterest: 'Interest', colBalance: 'Balance',
    emptyHint: 'Fill in loan details to calculate', phAmount: 'e.g. 70', phRate: 'e.g. 3.25'
  },
  TaxCalculator: {
    title: 'Income Tax Calculator', type: 'Income Type', typeSalary: 'Salary', typeBonus: 'Year-end Bonus', typeLabor: 'Labor Service',
    salary: 'Pre-tax Monthly Income', socialInsurance: 'Social Insurance + Housing Fund (/mo)', deduction: 'Special Deductions (/mo)',
    threshold: 'Tax Threshold (/mo)',
    bonus: 'Bonus Amount', bonusSalaryLabel: 'Does monthly salary reach threshold?',
    yes: 'Yes', no: 'No',
    mergeIncome: 'Merge into Income',
    labor: 'Labor Income', result: 'Tax Due', taxable: 'Taxable Income',
    afterTax: 'After-tax Income',
    phSalary: 'e.g. 20000', phSocial: 'e.g. 4000', phDeduction: 'e.g. 3000',
    phThreshold: '5000', phBonus: 'e.g. 100000', phLabor: 'e.g. 50000',
    rateRefTitle: 'Tax Rate Reference',
    colLevel: 'Level', colTaxableRange: 'Taxable Income (Monthly)', colRate: 'Rate', colQuickDeduction: 'Quick Deduction',
    emptyHint: 'Enter income details to calculate tax',
    taxFree: 'Taxable income ≤ 0, no tax due',
    rateInfo: 'Applicable rate {rate}%, quick deduction {quick}',
    bonusInfo: 'Bonus ÷ 12 = {avg} → rate {rate}%, quick deduction {quick}',
    laborFree: 'Labor income ≤ 800, tax exempt',
    laborLow: 'Deduct 800 then 20% rate',
    laborMid20: 'Deduct 20% then 20% rate',
    laborMid30: 'Deduct 20% then 30% surcharge, quick deduction 2000',
    laborMid40: 'Deduct 20% then 40% surcharge, quick deduction 7000',
    copyTax: 'Tax due: {tax}\nAfter-tax income: {afterTax}',
    bracketUpTo: 'Up to {n}', bracketRange: '{from} ~ {to}', bracketOver: 'Over {n}'
  },
  BmiCalculator: {
    title: 'BMI Calculator', height: 'Height', weight: 'Weight',
    result: 'Your BMI', category: 'Category', idealWeight: 'Ideal Weight {min} ~ {max} kg',
    underweight: 'Underweight', normal: 'Normal', overweight: 'Overweight', obese: 'Obese',
    hint: 'Enter height and weight to calculate BMI'
  },
  BabyHeight: {
    title: 'Baby Height Predictor', father: 'Father (cm)', mother: 'Mother (cm)',
    boy: 'Predicted (Boy)', girl: 'Predicted (Girl)', formula: 'Genetic Formula',
    boyShort: 'Boy', girlShort: 'Girl', fatherShort: 'Father', motherShort: 'Mother',
    compare: 'Height Comparison',
    formulaHint: 'Formula: Boy=(Father+Mother+13)/2, Girl=(Father+Mother-13)/2. ±5cm range. Actual height is affected by nutrition, exercise, and sleep.',
    hint: 'Enter parent heights (cm) to predict adult height'
  },
  CompoundInterest: {
    title: 'Compound Interest Calculator', principal: 'Principal', rate: 'Annual Rate (%)',
    years: 'Term (Years)', frequency: 'Compounding', yearly: 'Yearly', monthly: 'Monthly', daily: 'Daily',
    total: 'Total Amount', totalInterest: 'Total Interest', chart: 'Growth',
    unitYuan: '', effRate: 'Effective Rate', chartTitle: 'Yearly Growth',
    legendPrincipal: 'Principal', legendInterest: 'Interest',
    yearLabel: 'Y{y}', detailTitle: 'Yearly Breakdown ({n} years)',
    colYear: 'Year', colStart: 'Start Balance', colInterest: 'Interest', colEnd: 'End Balance',
    emptyHint: 'Enter deposit details to calculate compound interest',
    phPrincipal: 'e.g. 100000', phRate: 'e.g. 3.5'
  },
  BloodType: {
    title: 'Blood Type Inheritance', father: 'Father', mother: 'Mother',
    result: 'Possible Types', probability: 'Probability', table: 'Inheritance Table',
    type: 'Type', selectHint: 'Select parent blood types to see possible child types',
    parentTypes: 'Parent Types'
  },
  Flowchart: {
    title: 'Flowchart Maker', shapes: 'Shapes', tools: 'Tools', exportPng: 'Export PNG', exportSvg: 'Export SVG',
    clear: 'Clear', sample: 'Sample', undo: 'Undo', redo: 'Redo',
    autoLayout: 'Auto Layout', delete: 'Delete', selectAll: 'Select All'
  },
  Mindmap: {
    title: 'Mind Map', input: 'Outline', phInput: 'One node per line, use Tab for indentation...',
    hint: '```\nCentral Topic\n\tChild 1\n\t\tChild 1.1\n\tChild 2\n```'
  },
  SequenceDiagram: {
    title: 'UML Sequence Diagram', addObject: 'Add Object', addActor: 'Add Actor',
    addFragment: 'Fragment', fragmentAlt: 'alt', fragmentOpt: 'opt',
    fragmentLoop: 'loop', fragmentPar: 'par', fragmentBreak: 'break',
    editLabel: 'Double-click to edit', hint: 'Click first object, then second to link'
  },
  ChartMaker: {
    title: 'Chart Maker', subtitle: 'Enter data to generate charts instantly',
    typeLabel: 'Chart Type', typeBar: 'Bar Chart', typeLine: 'Line Chart',
    typePie: 'Pie Chart', typeHBar: 'Horizontal Bar', titleLabel: 'Chart Title',
    dataLabel: 'Label', dataValue: 'Value', addRow: 'Add Row', download: 'Download PNG',
    phLabel: 'Label', phValue: 'Value', phTitle: 'Chart title (optional)',
    stats: '{n} items · Total {total}',
    sampleTitle: '2025 H1 Sales',
    sampleMonths: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    colLabel: 'Label', colValue: 'Value'
  },
  GeometryDraw: {
    title: 'Geometry Drawing', modePoint: 'Point', modeLine: 'Line', modeCircle: 'Circle',
    modeTriangle: 'Triangle', modeQuad: 'Quadrilateral', modeFunc: 'Function',
    btnExportPng: 'Export PNG', btnExportSvg: 'Export SVG', btnClear: 'Clear',
    templates: 'Templates', undo: 'Undo', redo: 'Redo', grid: 'Grid'
  },
  FunctionPlot: {
    title: 'Function Plotter', input: 'Function', phInput: 'e.g. sin(x), x^2-4*x+3',
    btnPlot: 'Plot', xRange: 'X Range', yRange: 'Y Range',
    basic: 'Basic', trig: 'Trig', exp: 'Exp',
    autoFit: 'Auto Fit', lockY: 'Lock Y',
    tangent: 'Tangent', integral: 'Integral', clear: 'Clear',
    showKeyPoints: 'Show Key Points',
    hide: 'Hide', show: 'Show',
    exportPng: 'Export PNG', exportSvg: 'Export SVG',
    cursorHint: 'Scroll to zoom | Shift+drag to pan | Double-click for tangent',
    errSyntax: 'Syntax error'
  },
  ChineseConverter: {
    title: 'Chinese Converter', input: 'Input', output: 'Result',
    direction: 'Direction', toTraditional: 'Simp → Trad', toSimplified: 'Trad → Simp',
    phInput: 'Paste text...', phStoT: 'Enter Simplified Chinese...', phTtoS: 'Enter Traditional Chinese...',
    phOutput: 'Result...'
  },
  PinyinConverter: {
    title: 'Text to Pinyin', input: 'Enter Chinese text to convert to Pinyin', output: 'Result',
    mode: 'Format', modeTone: 'Tone Marks', modeNumber: 'Tone Numbers', modeNone: 'No Tones',
    phInput: 'Enter Chinese text, e.g. 重庆是一座美丽的山城', phOutput: 'Pinyin result...',
    tokens: 'Character Map', multiChar: 'Polyphone', identified: 'Identified',
    charsCount: '{n} characters', multiCount: '{n} polyphones',
    emptyHint: 'Enter Chinese text to convert', copied: 'Pinyin copied'
  },
  AsciiArt: {
    title: 'ASCII Art Generator', mode: 'Mode', imgToAscii: 'Image to ASCII', textToAscii: 'Text to ASCII',
    upload: 'Upload Image', uploadHint: 'PNG / JPG / WebP', width: 'Width',
    dropText: 'Drop image here or', clickUpload: 'click to upload',
    charset: 'Charset', charsetStandard: 'Standard', charsetSimple: 'Simple', charsetCustom: 'Custom',
    font: 'Font Style', copy: 'Copy', phText: 'Enter text...',
    outputPreview: 'Preview', metaChars: '{w} x {h} chars',
    emptyImage: 'Upload an image to generate ASCII art', emptyText: 'Enter text to generate ASCII art',
    copied: 'ASCII art copied',
    useCases: 'Use cases: code comments · terminal banners · README art'
  },
  BarcodeGenerator: {
    title: 'Barcode Generator', input: 'Content', format: 'Format',
    formatCode128: 'CODE128', formatEAN: 'EAN-13', formatUPC: 'UPC-A',
    formatCode39: 'CODE39', formatITF: 'ITF',
    download: 'Download PNG', random: 'Random',
    hint: 'Select barcode type and enter content to generate',
    hintCode128: 'General | Digits + letters + symbols, logistics/warehouse/shipping',
    hintEAN: 'Retail | 13 digits, country prefix (China:690-699), check digit auto-calculated',
    hintUPC: 'US/Canada Retail | 12 digits, check digit auto-calculated',
    hintCode39: 'Industrial | Digits + uppercase + 7 symbols, automotive/defense/medical',
    hintITF: 'Carton Logistics | 14 digits, corrugated box bulk shipping labels',
    valid: 'Valid format',
    errEAN: 'At least 12 digits, auto-fills check digit at 12',
    errUPC: 'At least 11 digits, auto-fills check digit at 11',
    errITF: 'Exactly 14 digits required',
    errCode39: 'Only digits, uppercase letters, - . $ / + % space',
    errCode128: 'Only printable ASCII characters',
    errDigitOnly: 'Digits only',
    errTooLong: 'Input too long'
  },
  BarcodeDecoder: {
    title: 'Barcode Decoder', dropHint: 'Drag or click to upload a barcode image', tip: 'Supports EAN/UPC/CODE128/CODE39/ITF/CODABAR and more 1D formats',
    btnDecode: 'Decode', decoding: 'Decoding...', found: 'Decoded',
    content: 'Content', format: 'Format', position: 'Position',
    redecode: 'Decode again', retry: 'Retry', notFound: 'No barcode found, check image clarity',
    decodeFail: 'Decode failed', notSupported: 'BarcodeDetector API not supported, please use Chrome 88+ or Edge 88+'
  },
  MbtiTest: {
    title: 'MBTI Personality Test', subtitle: 'Answer honestly — there are no right or wrong answers', question: 'Q{n}/{total}', prev: 'Previous', next: 'Next',
    viewResult: 'See My Personality Type',
    result: 'Your Result', typeLabel: 'Your Type', description: 'Description',
    career: 'Suitable Careers', restart: 'Restart',
    dimE: 'Extravert (E)', dimI: 'Introvert (I)', dimS: 'Sensing (S)', dimN: 'Intuition (N)',
    dimT: 'Thinking (T)', dimF: 'Feeling (F)', dimJ: 'Judging (J)', dimP: 'Perceiving (P)',
    types: {
      ISTJ:{name:'Inspector',desc:'Practical, meticulous, and rule-abiding. An excellent organizer and reliable executor. Suitable for roles in accounting, auditing, and civil service.'},
      ISFJ:{name:'Protector',desc:'Warm, loyal, and quietly dedicated. Attentive to others\' needs and a guardian of the team. Suitable for healthcare, education, and social work.'},
      INFJ:{name:'Advocate',desc:'Idealistic, insightful, and meaning-driven. Understands deep motivations and is a quiet change-maker. Suitable for counseling, writing, and HR.'},
      INTJ:{name:'Architect',desc:'Strategic, independent, and excellence-driven. Skilled at system planning and long-term vision. Suitable for research, engineering, and consulting.'},
      ISTP:{name:'Virtuoso',desc:'Calm, hands-on, and curious about how things work. Skilled at solving practical technical problems. Suitable for engineering, repair, and data analysis.'},
      ISFP:{name:'Adventurer',desc:'Gentle, aesthetically sensitive, and present-focused. Discovers and creates beauty. Suitable for design, art, and crafts.'},
      INFP:{name:'Mediator',desc:'Rich inner world, empathetic, and value-driven. Understands emotions and creative expression. Suitable for writing, art, and counseling.'},
      INTP:{name:'Logician',desc:'Rational, curious, and truth-seeking. Skilled at logical reasoning and innovative thinking. Suitable for STEM research, programming, and philosophy.'},
      ESTP:{name:'Entrepreneur',desc:'Energetic, action-oriented, and adventurous. Seizes opportunities and makes quick decisions. Suitable for sales, startups, and sports.'},
      ESFP:{name:'Entertainer',desc:'Enthusiastic, sociable, and joyful. Infectious energy and the center of attention. Suitable for performing arts, PR, and tourism.'},
      ENFP:{name:'Campaigner',desc:'Warm, creative, imaginative, and empathetic. Strong curiosity and infectious enthusiasm. Suitable for creative fields, education, and media.'},
      ENTP:{name:'Debater',desc:'Quick-witted, argumentative, and unconventional. Discovers new possibilities and opportunities. Suitable for startups, law, and consulting.'},
      ESTJ:{name:'Executive',desc:'Highly organized, decisive, and efficiency-focused. Skilled at management and execution. Suitable for management, administration, and military.'},
      ESFJ:{name:'Consul',desc:'Caring, responsible, collaborative, and harmony-focused. An excellent organizer and supporter. Suitable for education, administration, and service.'},
      ENFJ:{name:'Protagonist',desc:'Charismatic, cares about others\' growth, and highly motivating. A natural leader and educator. Suitable for education, training, and nonprofit.'},
      ENTJ:{name:'Commander',desc:'Decisive, confident, leadership-oriented, and achievement-driven. A powerful strategist and executor. Suitable for management, startups, and finance.'}
    },
    questions: [
      {text:'In social settings, you usually',a:'Initiate conversations with new people and feel energized',b:'Prefer being with familiar people; long socializing drains you'},
      {text:'When making decisions, you tend to',a:'Analyze pros and cons based on objective facts and logic',b:'Consider others\' feelings and values, seeking harmony and consensus'},
      {text:'In daily life, you focus more on',a:'Specific details and practical experience, focused on the present',b:'Abstract concepts and future possibilities, focused on the big picture'},
      {text:'Your work and lifestyle lean toward',a:'Being planned, organized, preferring to arrange things in advance',b:'Being flexible and open, preferring to keep options open and adapt'},
      {text:'When reading or studying, you prefer',a:'Focusing on facts, data, and concrete cases',b:'Focusing on theoretical frameworks and conceptual systems'},
      {text:'When interacting with others, you tend to',a:'Speak frankly, address issues directly, able to give objective criticism',b:'Speak tactfully, mindful of others\' emotions, avoiding conflict'},
      {text:'On weekends you prefer',a:'Going to parties, sports, or outdoor activities',b:'Staying home reading, watching movies, or doing personal projects'},
      {text:'When solving problems, you usually',a:'Act first and adjust later, figuring it out through trial and error',b:'Think first and act later, mentally running through possibilities'},
      {text:'At work, you care more about',a:'Clear goals, structured processes, and visible results',b:'Meaningful work, personal growth, and team atmosphere'},
      {text:'When facing a new task, you tend to',a:'Start with existing experience and known methods',b:'Try entirely new approaches and ideas, even if risky'},
      {text:'In a team, you usually',a:'Speak up actively, eagerly share ideas, and drive discussion',b:'Listen first then express, speaking after careful consideration'},
      {text:'Your desk or room is usually',a:'Neat and organized, preferring tidiness',b:'Casual and natural, as long as you know where things are'}
    ]
  },
  ExpressTracking: {
    title: 'Express Tracking', input: 'Tracking No.', btnQuery: 'Track',
    hintAuto: 'Auto-detect courier and redirect to the official tracking page', phInput: 'Enter tracking number...',
    courier: 'Courier', trackingNo: 'Tracking No.', goOfficial: 'Track Online',
    requery: 'Search Again', courierList: '{n} couriers supported · Click an example to try',
    emptyInput: 'Please enter a tracking number', notRecognized: 'Unable to identify this tracking number. Please check and try again'
  },
  WatermarkRemove: {
    title: 'Watermark Remover', upload: 'Upload Image', uploadHint: 'PNG / JPEG / WebP · 20MB',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    lassoMode: 'Selection Mode', lasso: 'Lasso', brushMode: 'Brush', brushSize: 'Brush Size',
    clear: 'Clear', undoVertex: 'Undo Vertex', dblClickClose: 'Double-click to close',
    btnRemove: 'Remove Watermark', processing: 'Processing...', loadEngine: 'Loading engine...',
    original: 'Original', result: 'Result', download: 'Download',
    reupload: 'Upload Again', maxSize: 'Max 20MB', noFile: 'Please upload an image',
    noMask: 'No watermark area marked', imgParseFail: 'Image parse failed',
    cvLoadFail: 'OpenCV engine load failed', cvTimeout: 'OpenCV engine load timeout',
    imgLoadFail: 'Image load failed, please retry', done: 'Done'
  },
  WordToPdf: {
    title: 'Word to PDF', upload: 'Upload Word', uploadHint: '.docx / .doc · Max 50MB',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    btnConvert: 'Convert to PDF', processing: 'Converting, please wait...',
    generated: 'PDF Generated', download: 'Download PDF', reupload: 'Convert Again',
    maxSize: 'Max 50MB', convertFail: 'Conversion failed', note: 'Server requires Microsoft Office'
  },
  PdfToWord: {
    title: 'PDF to Word', upload: 'Upload PDF', uploadHint: 'Max 50MB',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    btnConvert: 'Convert to Word', processing: 'Converting, please wait...',
    generated: 'Word Generated', download: 'Download .docx', reupload: 'Convert Again',
    maxSize: 'Max 20MB', convertFail: 'Conversion failed'
  },
  PptToWord: {
    title: 'PPT to Word', upload: 'Upload PPT', uploadHint: '.ppt / .pptx · 50MB',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    btnConvert: 'Convert to Word', processing: 'Converting PPT, please wait...',
    generated: 'Word Document Generated', download: 'Download Word', reupload: 'Convert Again',
    maxSize: 'File cannot exceed 50MB', convertFail: 'Conversion failed', note: 'Text content only'
  },
  ExcelToWord: {
    title: 'Excel to Word', upload: 'Upload Excel', uploadHint: '.xls / .xlsx · 50MB',
    dropText: 'Drop file here, or', clickUpload: 'click to upload',
    btnConvert: 'Convert to Word', processing: 'Converting Excel, please wait...',
    generated: 'Word Document Generated', download: 'Download Word', reupload: 'Convert Again',
    maxSize: 'File cannot exceed 50MB', convertFail: 'Conversion failed'
  },
  PdfSplit: {
    title: 'PDF Split', upload: 'Upload PDF', uploadHint: '.pdf format, Max 50MB',
    dropText: 'Drag & drop PDF here, or click to upload', clickUpload: 'click to upload',
    selectFile: 'Select File', pageRange: 'Page Range', phRange: 'e.g. 1-3,5,7-10',
    btnSplit: 'Split', splitting: 'Splitting...', download: 'Download', reupload: 'Re-upload',
    maxSize: 'Max 50MB', hintPageRange: 'Comma-separated, e.g. 1,3,5-8',
    errNeedPdf: 'Please select a PDF file', errNeedPages: 'Please enter a page range', errSplit: 'Split failed',
    clickUploadText: 'click to upload'
  },
  TimezoneConverter: {
    title: 'Timezone Converter', worldClock: 'World Clock', converter: 'Timezone Converter',
    fromTz: 'From', toTz: 'To', dateTimeLabel: 'Date & Time', btnNow: 'Now', result: 'Result',
    dateTimePlaceholder: 'Select date & time'
  },
  TableStructure: {
    title: 'MySQL Schema Doc', host: 'Host', port: 'Port', user: 'User',
    password: 'Password', database: 'Database', btnExport: 'Export Word',
    passwordPlaceholder: 'Leave blank if no password',
    hostRequired: 'Host is required', userRequired: 'User is required', databaseRequired: 'Database is required',
    note: 'Includes table name, comments, field names, types, constraints and remarks',
    tipUsage: 'Enter MySQL connection info and click Export to download a Word document containing all table schemas',
    tipSecurity: 'For internal network use only. Do not transmit database passwords over the public internet',
    exportSuccess: 'Export successful', exportFail: 'Export failed, please check your connection info',
    directMode: 'Direct', agentMode: 'Agent',
    sessionId: 'Session ID', phSessionId: 'Enter session ID from Agent',
    sessionIdRequired: 'Session ID is required',
    downloadAgent: 'Download Agent', agentHelp: "Can't reach LAN database? Download Agent to bridge",
    errAgentConnect: 'Cannot connect to Agent. Verify session ID and ensure Agent is running',
    agentDisconnected: 'Agent disconnected'
  },
  SwaggerDoc: {
    title: 'Swagger API Doc', version: 'Version', version2: '2.x (/v2/api-docs)', version3: '3.0 (/v3/api-docs)',
    url: 'Doc URL', phUrl: 'https://example.com/v2/api-docs',
    btnGenerate: 'Generate', note: 'Auto-parses parameters, response codes & data structures into a Word document',
    urlRequired: 'URL is required', tipUsage: 'Enter the Swagger/OpenAPI JSON doc URL, select the version, and generate a Word-format API document',
    tipExample2: 'Swagger 2.x example', tipExample3: 'OpenAPI 3.0 example',
    generateSuccess: 'Generated successfully', generateFail: 'Generation failed, please check the URL and version',
    directMode: 'Direct', agentMode: 'Agent',
    sessionId: 'Session ID', phSessionId: 'Enter session ID from Agent',
    sessionIdRequired: 'Session ID is required',
    downloadAgent: 'Download Agent', agentHelp: "Swagger URL is on internal network? Download Agent to fetch it",
    errAgentConnect: 'Cannot connect to Agent. Verify session ID and ensure Agent is running',
    agentDisconnected: 'Agent disconnected'
  }
}
